import smarty from "refractor/smarty";
export default smarty;